import React from 'react';
import { Box } from '@material-ui/core';

interface Props {
  children: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: React.FC<Props> = ({ index, value, children }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};
